import { Connect, Message, SocketObservable } from '@genesislcap/foundation-comms';
import { DI } from '@microsoft/fast-foundation';

export interface IAppConfigService {
    isMaskingFeatureEnabled(): Promise<any>;
}

class AppConfigServiceImpl implements IAppConfigService {

    constructor(
        @Connect private connect: Connect,
    ) {}

    public async isMaskingFeatureEnabled(): Promise<Message<any>> {
        return this.connect.request('MASKING_FEATURE_ENABLED', {
            REQUEST: true,
        })
    }
}

export const IAppConfigService = DI.createInterface<IAppConfigService>((x) => x.singleton(AppConfigServiceImpl));
